import { useState } from 'react';
import { OrderBy, PaginationParams, SortParams } from './use-sort-and-pagination.types';

type UseSortAndPaginationProps<T extends SortParams | undefined> = {
  defaultPagination?: PaginationParams;
  defaultSorting?: T;
};

export const DEFAULT_PAGINATION = { page: 1, items_per_page: 12 } satisfies PaginationParams;

export function useSortAndPagination<T extends SortParams | undefined>(
  { defaultPagination = DEFAULT_PAGINATION, defaultSorting }: UseSortAndPaginationProps<T> = {
    defaultPagination: DEFAULT_PAGINATION,
  }
) {
  const [sortDetails, setSortDetails] = useState<T>(defaultSorting as T);
  const [paginationDetails, setPaginationDetails] = useState<PaginationParams>(defaultPagination);

  const onPaginationChanged = (page: number, items_per_page: number) => {
    setPaginationDetails({ page, items_per_page });
  };

  const onSortChange = (sort_by: string, order_by: OrderBy) => {
    setSortDetails({ sort_by, order_by } as T);
  };

  return { sortDetails, onSortChange, paginationDetails, onPaginationChanged };
}
